<template>
  <div class="supplier-register-page" data-name="供应商注册">
    <!-- 头部导航 -->
    <GlobalHeader />
    <!-- 主体内容区域 -->
    <div class="main-content">
      <p class="page-title">供应商注册信息填写</p>

      <a-form-model ref="ruleForm" :model="form" :rules="rules" class="register-form">
        <a-form-model-item label="供应商中文名称：" prop="Name" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-input size="large" v-model="form.Name" placeholder="请填写供应商名称" />
        </a-form-model-item>

        <a-form-model-item label="统一社会信用代码：" prop="Uscc" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-input size="large" v-model="form.Uscc" placeholder="请填写18位统一社会信用代码" />
        </a-form-model-item>

        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item label="联系人：" prop="ContactName" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input size="large" v-model="form.ContactName" placeholder="请填写姓名" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="邮箱：" prop="Email" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input size="large" v-model="form.Email" placeholder="请填写电子邮箱" />
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item label="登录手机号：" prop="Phone" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input size="large" v-model="form.Phone" placeholder="请填写登录手机号" />
            </a-form-model-item>

            <!-- <a-form-model-item label="登录密码：" prop="PassWord" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input-password size="large" v-model="form.PassWord" placeholder="请填写登录密码" />
            </a-form-model-item> -->

            <a-form-model-item prop="SmsCode" :wrapper-col="{ span: 16, offset: 8 }">
              <VerifyCodeInput v-model="form.SmsCode" :phone-number="form.Phone" :sms-code-type="2" send-type="register" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
             <a-form-model-item label="营业执照：" prop="BusinessLicenseFile" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <div class="upload-container">
                <a-upload name="file" :multiple="false" :before-upload="beforeUpload" :file-list="form.BusinessLicenseFile"
                  @change="handleFileChange">
                  <a-button size="large"> <a-icon type="upload" /> 上传附件 </a-button>
                </a-upload>
                <span class="upload-tip">请上传pdf、jpg或png格式的文件，单个文件不超过3M</span>
              </div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-form-model-item :wrapper-col="{ span: 24 }" style="text-align: center; margin-top: 40px">
          <a-button type="primary" :loading="loading" @click="onSubmit" class="submit-button">
            确认注册
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import GlobalHeader from "@/components/GlobalHeader.vue";
import VerifyCodeInput from "@/components/VerifyCodeInput.vue";
import { supplierRegister } from "@/api/login.js";
export default {
  name: "SupplierRegister",
  components: {
    GlobalHeader,
    VerifyCodeInput,
  },
  data() {
    return {
      type: this.$route.query.type,
      loading: false,
      form: {
        Name: "",
        Uscc: "",
        // PassWord: "",
        ContactName: "",
        Phone: "",
        Email: "",
        SmsCode: "",
        BusinessLicenseFile: [],
      },
      rules: {
        Name: [
          { required: true, message: "请填写供应商名称", trigger: "blur" },
        ],
        Uscc: [
          {
            required: true,
            message: "请填写18位统一社会信用代码",
            trigger: "blur",
          },
        ],
        // PassWord: [
        //   { required: true, message: "请填写登录密码", trigger: "blur" },
        // ],
        ContactName: [
          { required: true, message: "请填写姓名", trigger: "blur" },
        ],
        Phone: [
          { required: true, message: "请填写登录手机号", trigger: "blur" },
        ],
        SmsCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        Email: [{ required: true, message: "请填写电子邮箱", trigger: "blur" }],
        BusinessLicenseFile: [{ required: true, message: '请上传营业执照', trigger: 'change', type: 'array' }],
      },
    };
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          
          const formData = new FormData();
          formData.append('Name', this.form.Name);
          formData.append('Uscc', this.form.Uscc);
          // formData.append('PassWord', this.form.PassWord);
          formData.append('ContactName', this.form.ContactName);
          formData.append('Phone', this.form.Phone);
          formData.append('SmsCode', this.form.SmsCode);
          formData.append('Email', this.form.Email);
          
          if (this.form.BusinessLicenseFile && this.form.BusinessLicenseFile.length > 0) {
            // Assuming single file upload based on UI, but using loop just in case or for consistency
             this.form.BusinessLicenseFile.forEach((file) => {
                formData.append(`BusinessLicenseFile`, file.originFileObj);
              });
          }

          supplierRegister(formData).then((res) => {
            if(res){
               this.$message.success("注册成功");
                this.$router.push({
                  path: "/login",
                  query: {
                    type: this.type,
                  },
                });
            }
          }).catch(err => {
            // this.$message.info(err.message);
          }).finally(() => {
            this.loading = false;
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
     // 拦截自动上传，改为手动提交
    beforeUpload(file) {
      this.form.BusinessLicenseFile = [file]; // Limit to single file if needed, or [...this.form.BusinessLicenseFile, file] for multiple
      return false;
    },
    handleFileChange(info) {
      // 由于使用了 beforeUpload 拦截，这里主要处理移除文件的逻辑
      let fileList = [...info.fileList];
      // Limit to 1 file if strictly business license
      fileList = fileList.slice(-1);
      this.form.BusinessLicenseFile = fileList;
    },
  },
};
</script>

<style lang="less" scoped>
@import "./Register.less";
.upload-container {
  display: flex;
  flex-direction: column;
  .upload-tip {
    font-size: 12px;
    color: #999;
    margin-top: 5px;
  }
}
</style>
